import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "..";
import { AboEnrichmentRequest, AboEnrichmentResponse } from "./AboEnrichmentAPI.types";

export const aboEnrichmentAPI = createApi({
  reducerPath: "aboEnrichmentAPI",
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getABOEnrichmentData: builder.mutation<AboEnrichmentResponse, AboEnrichmentRequest>({
      query: (params) => {
        const body = {
          affAbos: params.affAbos,
          locale: params.locale,
          isoCountryCode: params.isoCountryCode,
          bonusPeriod: params.bonusPeriod,
          ...(params.customers && params.customers.length > 0 ? { customers: params.customers } : {}),
          ...params.kpis.reduce(
            (acc, kpi) => {
              acc[kpi] = true;
              return acc;
            },
            {} as Record<string, boolean>,
          ),
        };

        return {
          url: `/abo-enrichment/api/enrich`,
          method: "POST",
          body,
        };
      },
    }),
  }),
});

export const { useGetABOEnrichmentDataMutation } = aboEnrichmentAPI;
